import * as Sentry from '@sentry/nextjs';
import { cmsProxyApi } from './cmsProxyApi';

const pressCenterService = {
  async fetchAnnouncements({
    tags,
  }: {
    tags: string[];
  }): Promise<AnnouncementsResponse> {
    try {
      const { data } = await cmsProxyApi.get('/resources', {
        params: {
          resourceType: 'article',
          page: 0,
          tags,
        },
      });

      return data;
    } catch (error) {
      Sentry.captureException(error);
      return null;
    }
  },
};

export default pressCenterService;
